import { render, staticRenderFns } from "./TimerCountdown.vue?vue&type=template&id=dd36b8f0&scoped=true&"
import script from "./TimerCountdown.vue?vue&type=script&lang=js&"
export * from "./TimerCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd36b8f0",
  null
  
)

export default component.exports